// extracted by mini-css-extract-plugin
export var card = "_mj-1";
export var summary = "_mj-0";